import { schemaCommon } from "components/Reusable/Bit/FormikSchema"
import * as yup from "yup"

const companiesInitialValues = {
  firstName: "",
  lastName: "",
  companyName: "",
  companyIdNumber: "",
  phoneNumber: "",
  email: "",
  notes: "",
  gRecaptchaResponse: true,
}

const schemaCompanies = yup
  .object({
    firstName: schemaCommon.firstName,
    lastName: schemaCommon.lastName,
    companyName: schemaCommon.firstName,
    companyIdNumber: schemaCommon.companyId,
    phoneNumber: schemaCommon.phoneNumberCompany,
    email: schemaCommon.email,
  })
  .defined()

export default { companiesInitialValues, schemaCompanies }
